var map = {
	"./TBB1.jpg": "dca1",
	"./TBB2.png": "a826",
	"./TBB3.jpg": "e503",
	"./TBB4.jpg": "7467",
	"./TBB5.jpg": "b60e",
	"./TBB6.jpg": "8ec6",
	"./about.jpg": "a46c",
	"./babywearing.jpg": "6bf7",
	"./colored_illustration.png": "2526",
	"./contact.jpg": "a53d",
	"./feeding.png": "3241",
	"./gift_card.jpg": "e833",
	"./handsigns.jpg": "6faf",
	"./home.png": "fbf5",
	"./kobido.jpg": "7ca4",
	"./main_colored_logo.png": "392d",
	"./massage.jpg": "7e75",
	"./motherhood_return.png": "e00d",
	"./prenatal_appointment.png": "ab3c",
	"./reflexo.jpg": "f0ea",
	"./sleep.jpg": "43f0",
	"./training.png": "85be",
	"./wrapped_bath.jpg": "469d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";